import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper from '@styles/colors';
import ModalWrapper from '@components/modal/ModalWrapper';
import MoreButton from '@components/common/moreButton';
import ActionMenu from '@components/common/actionMenu';

import { scaleOP } from '@components/frame';

import { ColorFunction } from '@styles/colors/types';
import { fontOP } from '@styles/fonts';
import { useManageOPNotesActions } from './hooks/useManageOPNotesActions';
import { RetrievedDocumentReferenceLink } from '@v2/components/imageHandling/types/types';
import AttachModal from '@v2/components/imageHandling/components/Header/components/AttachModal';
import RemoveAttachmentModal from '@v2/components/imageHandling/components/Header/components/RemoveAttachmentModal';

export interface ActionsProps {
  C: ColorFunction;
  documentId?: number;
  documentFileName?: string;
  removeNote: (documentId?: number) => void;
  onRename: () => void;
}

const Actions: FC<ActionsProps> = ({ C, removeNote, documentId, onRename }) => {
  const {
    rootRef,
    actionsMenuOpen,
    rootPosition,
    actionsConfig,
    attachModalOpen,
    setAttachModalOpen,
    setActionsMenuOpen,
    selectedNote,
    handleToggleFavoriteLink,
    handleStartRemovingAttachment,
    showRemoveAttachmentModal,
    setShowRemoveAttachmentModal,
    handleConfirmRemoveAttachment,
  } = useManageOPNotesActions({ onRename, removeNote, documentId });

  return (
    <>
      <View ref={rootRef}>
        <MoreButton C={C} onPress={() => setActionsMenuOpen(true)} scale={scaleOP} />
      </View>
      <ModalWrapper isVisible={actionsMenuOpen} C={C} onBackdropPress={() => setActionsMenuOpen(false)}>
        <View
          style={{
            position: 'absolute',
            backgroundColor: C('Background/Light/Field'),
            borderRadius: scaleOP(12),
            top: rootPosition.top,
            right: rootPosition.right,
          }}
        >
          <ActionMenu C={C} items={actionsConfig.filter((i) => !i.ignore)} scale={scaleOP} font={fontOP} />
        </View>
      </ModalWrapper>
      {attachModalOpen && (
        <AttachModal
          key="attachModal"
          visible={attachModalOpen}
          onClose={() => {
            setAttachModalOpen(false);
            setActionsMenuOpen(false);
          }}
          links={(selectedNote?.links || []) as RetrievedDocumentReferenceLink[]}
          onToggleFavorite={handleToggleFavoriteLink}
          onRemoveAttachment={(attachmentToRemove) => {
            setAttachModalOpen(false);
            handleStartRemovingAttachment(attachmentToRemove);
          }}
          imageId={selectedNote?.id}
          fileName={selectedNote?.fileName}
          img={selectedNote}
          scale={scaleOP}
          font={fontOP}
        />
      )}
      <RemoveAttachmentModal
        key="removeAttachmentModal"
        visible={showRemoveAttachmentModal}
        onClose={() => setShowRemoveAttachmentModal(false)}
        onConfirm={handleConfirmRemoveAttachment}
      />
    </>
  );
};

export default ColorWrapper(Actions);
